import React, { useState, useRef, useContext } from 'react';
import { Button } from 'anf-core-react';
import TmntHtml from '../../../tools/TmntHtml';
import ProductNotificationsDialog from '../ProductNotificationsDialog/ProductNotificationsDialog';
import ProductPageContext from '../../../contexts/ProductPageContext';
import AnalyticsTriggers from '../../../analytics/analyticsTriggers';

export default function ProductNotificationsButton({ brand, tmntData, displaySignupText = false }) {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const notifyButtonRef = useRef(null);
  const normalizedBrand = brand === 'gh' ? 'hol' : brand;
  const ProductPageState = useContext(ProductPageContext);
  const hasGoldenStateAnalytics = true;

  const handleOpenNotificationDialog = () => {
    setIsDialogOpen(true);
    AnalyticsTriggers.universalClick('click', 'product notification', hasGoldenStateAnalytics, ProductPageState);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
    setTimeout(() => {
      notifyButtonRef.current?.querySelector('button')?.focus();
    }, 0);
  };

  return (
    <div className="product-notifications-button-container" data-product-brand={normalizedBrand} data-testid="product-notifications-button-container">
      {displaySignupText && (
        <div className="product-notifications-signup-text">
          <TmntHtml value={tmntData?.productNotificationSignUp?.value} />
        </div>
      )}

      <div ref={notifyButtonRef}>
        <Button
          classList="product-notifications-button-container_button"
          variant="secondary"
          brand={normalizedBrand}
          isFullWidth
          onClick={handleOpenNotificationDialog}
        >
          {tmntData?.notifyMeButton?.value}
        </Button>
      </div>

      {isDialogOpen && (
        <ProductNotificationsDialog
          isOpen={isDialogOpen}
          onClose={handleCloseDialog}
          brand={normalizedBrand}
        />
      )}
    </div>
  );
}
